import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedUser: {},
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    },
  },
});

export const { setSelectedUser } = userSlice.actions;

export default userSlice.reducer;
